// extracted by mini-css-extract-plugin
module.exports = {"dealerRoot":"_2kFK2"};